import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Aasaan.ai" link="https://www.aasaanai.com/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is a no code platform for developing deep learning based text classifiers
    </ProjectCard>
    <ProjectCard title="Pytorch-RL" link="https://github.com/navneet-nmk/pytorch-rl" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  Repository containing model-free deep reinforcement learning algorithms implemented in Pytorch.
    </ProjectCard>
    <ProjectCard title="Stormy" link="https://github.com/navneet-nmk/Stormy" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  Accurate android weather app using Forecast.io
    </ProjectCard>
    <ProjectCard title="Navneet Blog" link="https://navneet-nmk.github.io/" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  A Blog where I write about my interests.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      